import { client } from ".";

async function fetchPage(page: number) {
	const { data } = await client.get<ResultList<Coupon>>(`/coupons`, {
		params: { page },
	});
	return data;
}

async function show(id: number) {
	const { data } = await client.get<Result<Coupon>>(`/coupons/${id}`);
	return data;
}

async function store(item: StoreCoupon) {
	const { data } = await client.post<Result<Coupon>>("/coupons", item);
	return data;
}

async function update(id: number, item: UpdateCoupon) {
	const { data } = await client.put<Result<Coupon>>(`/coupons/${id}`, item);
	return data;
}

async function destroy(id: number) {
	const { data } = await client.delete(`/coupons/${id}`);
	return data;
}

const couponsAPI = {
	fetchPage,
	show,
	store,
	update,
	destroy,
};

export default couponsAPI;
